import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const GettingRidDoubleChin = lazyWithPreload(
  () => import('./GettingRidDoubleChin'),
)
